/**
 * Customer-facing commercial sections at the bottom of invoices.
 *
 * Storage stays on invoice / org settings columns. Renderers consume
 * presentation objects ({ title, blocks }) and stay section-agnostic.
 *
 * Reserved for future sections (not implemented yet):
 * - purchase_order / customer_reference
 * - deposit_applied / remaining_balance
 * - late_payment_policy / early_payment_discount
 * - online_payment_link / qr_code
 */

export const INVOICE_COMMERCIAL_SECTION = Object.freeze({
  HOW_TO_PAY: "how_to_pay",
  PAYMENT_TERMS: "payment_terms",
  CUSTOMER_NOTES: "customer_notes",
  INVOICE_FOOTER: "invoice_footer",
});

/** Canonical customer-facing order under totals. */
export const INVOICE_COMMERCIAL_SECTION_ORDER = Object.freeze([
  INVOICE_COMMERCIAL_SECTION.HOW_TO_PAY,
  INVOICE_COMMERCIAL_SECTION.PAYMENT_TERMS,
  INVOICE_COMMERCIAL_SECTION.CUSTOMER_NOTES,
  INVOICE_COMMERCIAL_SECTION.INVOICE_FOOTER,
]);

export const CUSTOMER_NOTES_TITLE = "Customer Notes";
export const PAYMENT_TERMS_SECTION_TITLE = "Payment Terms";
/** Admin / settings label only — customer invoice renders footer text without a forced title. */
export const INVOICE_FOOTER_ADMIN_TITLE = "Invoice Footer";
